import { CONSULTATION_STEPS, MODULE_TYPE, OTHER_SERVICE, STEP_TYPE } from '@abiglobalhealth/go-types'
import { Consultation } from '@components/Consultation'
import { IndicationSurvey } from '@components/Consultation/steps/IndicationSurvey'
import { IndicationCategories } from '@components/Consultation/steps/Landing/IndicationCategories'
import Navigator from '@components/Consultation/steps/Navigator'
import { PharmacySelector } from '@components/Consultation/steps/WaitingForInfo/FulfillmentChoiceSelection/PharmacySelector'
import ConsultationLimitExceededWrapper from '@components/ConsultationLimitExceededWrapper'
import { Step } from '@components/Step'

import { useConsultationEnded } from '@/hooks/useConsultationEnded'
import { useConsultationStep } from '@/hooks/useConsultationStep'
import { useModule } from '@/hooks/useModule'
import { useStep } from '@/hooks/useStep'

export const Module = () => {
  const { currentModule } = useModule()
  const { currentStep } = useStep()
  const { currentConsultationStep } = useConsultationStep()
  const consultationEnded = useConsultationEnded()

  // We need to check if the current consultation step is answer in order to NO navigate home on rating (consultation status is ENDED but we still need to show the download button)
  if (!consultationEnded || currentConsultationStep === CONSULTATION_STEPS.ANSWER) return <Consultation />

  switch (currentModule?.type) {
    case MODULE_TYPE.CONSULTATION:
    case MODULE_TYPE.CONSULTATION_LANDING:
      if (currentModule.consultationType === OTHER_SERVICE.HEALTH_NAVIGATOR) {
        return currentStep?.type === STEP_TYPE.USER_FORM ? <Step /> : <Navigator />
      }

      if (currentStep?.type === STEP_TYPE.USER_FORM) return <Step />

      return (
        <ConsultationLimitExceededWrapper>
          <Consultation />
        </ConsultationLimitExceededWrapper>
      )

    case MODULE_TYPE.PHARMACY_SELECTOR:
      return <PharmacySelector />

    case MODULE_TYPE.INDICATION_CATEGORIES:
    case MODULE_TYPE.ASSESSMENT_SURVEY_CATEGORIES:
      return (
        <ConsultationLimitExceededWrapper>
          <IndicationCategories />
        </ConsultationLimitExceededWrapper>
      )

    case MODULE_TYPE.INDICATION_SURVEY:
      return <IndicationSurvey />

    case MODULE_TYPE.DEFAULT:
      return <Step />

    default:
      return null
  }
}
